var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6234_992)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.634682 6.37805C1.69052 9.93812 5.85186 13.7515 7.91446 15.3756C7.96386 15.4145 8.03003 15.4141 8.07893 15.3746C10.1981 13.6628 14.524 9.66502 15.4053 6.37805C16.2981 3.04821 14.6714 1.49673 13.3386 0.861386C12.141 0.290477 9.51221 0.615279 8.08138 3.32843C8.05495 3.37856 7.98073 3.3776 7.9556 3.3268C6.63 0.64681 4.17152 0.270252 2.9583 0.721807C1.66971 1.11004 -0.435466 2.76974 0.634682 6.37805Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.666667
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6234_992"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.f34fc9d6eb9d46a1bb3fd43b1f7d7bfc.svg";
export { ForwardRef as ReactComponent };